
export const ACTION_ADD_TO_END = "ACTION_ADD_TO_END";
export const ACTION_REPLACE_CONTENT = "ACTION_REPLACE_CONTENT";